import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "./http";
import wx from "weixin-js-sdk";
import "./vant";
import "@/assets/bg.less"
import PortalVue from 'portal-vue'

window.wx = wx
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

function init() {
  const token = localStorage.getItem('token');
  token ? localStorage.removeItem('token') : '';
}
init();
Vue.use(PortalVue)
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
